import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import {HttpClient} from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})

export class CommonService {
    _bradCrumbs: any = [];
    pageTitle: string = '';

    constructor(private router: Router ) { }

    toggleNavigationMenu(drawer){
        drawer.toggle()
    }

    returnRouteBradCrumbsData(){
        // this._route.data.subscribe(data => {
        //     console.log('service data ', data);
        //     return data
        // })

        // return this._route.snapshot.data['breadcrumb']

        // const root = this.router.routerState.snapshot.root;
        // console.log('root ', root);
        // return this.lastChild(root).data[0][data];

         this.router.events.subscribe((val) => {
            // see also 
            return val
            console.log('Router change ', val) 
        });
    }
}

/**
 * Safely updates `page` and `page_size` in any API query URL without creating duplicate
 * parameters or stripping other filter/conditional parameters.
 */
export function updateUrlPagination(baseUrl: string, pageNumber: number, pageSize: number): string {
  if (!baseUrl) return '';
  const [path, queryString] = baseUrl.split('?');
  const params = new URLSearchParams(queryString || '');
  params.set('page', String(pageNumber || 1));
  params.set('page_size', String(pageSize || 10));
  const cleanQuery = params.toString().replace(/%2C/gi, ',');
  return `${path}?${cleanQuery}`;
}